export const userInfoValidationRules = {
  maxLength: 50,
  minLength: 1,
  minLengthJobTitle: 0,
  minLengthUsername: 1,
  regexUsername: RegExp(/^[@.\-_a-zÀ-ÿ1-9]+$/i),
  regexName: RegExp(/^(?!.*[\s-]{2})[a-zÀ-ÿ0-9]+(?:[\s-][a-zÀ-ÿ0-9]+)*$/i),
  regexJobTitle: RegExp(/^[a-zÀ-ÿ0-9-\s]*$/i),
  regexEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
}

export enum AccountValidationFields {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  JOB_TITLE = 'job_title',
  USERNAME = 'username',
  COUNTRY = 'country',
  LANGUAGE_PREFERENCE = 'language_preference',
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirm_password',
  EULA_ACCEPTED = 'eula_accepted',
  EMAIL = 'email',
}

export enum ResetPasswordValidationFields {
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirm_password',
}
